import LabradorArticleHeader, {
  StandaloneArticleHeader,
  StandaloneArticleHeaderProps,
} from '@/components/ArticleHeader';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

const FeminaStandaloneArticleHeader: StandaloneComponent<StandaloneArticleHeaderProps> = ({ bylines, ...props }) => {
  const bylinesWithoutImages = bylines?.map((byline) => ({
    ...byline,
    image: '',
  }));

  return (
    <StandaloneArticleHeader
      {...mergeProps<StandaloneArticleHeaderProps>(
        { options: { variant: 'fourth' }, bylines: bylinesWithoutImages },
        props
      )}
    />
  );
};

export const standalone = FeminaStandaloneArticleHeader;

export default LabradorArticleHeader;
